export const products = [
    {
        id: 1,
        name: "Samesung Galaxy A6",
        price: 159.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product1.png"
    },
    {
        id: 2,
        name: "Iphone 11 128go",
        price: 899.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product2.png"
    },
    {
        id: 3,
        name: "Iphone 14 128go",
        price: 1029.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product3.png"
    },
    {
        id: 4,
        name: "Iphone 12 mini 256go",
        price: 729.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product4.png"
    },
    {
        id: 5,
        name: "Oppo find lite 126go",
        price: 199.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product5.png"
    },
    {
        id: 6,
        name: "Xiami MI 11 lite 128go",
        price: 259.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product6.png"
    },

    {
        id: 7,
        name: "Samesung S22 128go",
        price: 759.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product7.png"
    },

    {
        id: 8,
        name: "blackview A90 - 64go",
        price: 119.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product8.png"
    },

    {
        id: 9,
        name: "Iphone 12 - 64go",
        price: 549.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product9.png"
    },

    {
        id: 10,
        name: "Samsung A73-128go",
        price: 349.99,
        description: "Torem ipsum dolor sit amet, consectetur adipisicing elitsed do eiusmo tempor incididunt ut labore et dolore magna",
        image: "../images/product/product10.png"
    }

    

    
]